import React from 'react';
import { HomeIcon, LayoutGridIcon, PlayCircleIcon, MenuIcon } from 'lucide-react';

export type MainTabType = 'home' | 'devices' | 'automation' | 'menu';

interface BottomNavigationProps {
  activeTab: MainTabType;
  onChangeTab: (tab: MainTabType) => void;
  hasAlarms?: boolean;
}

export function BottomNavigation({ activeTab, onChangeTab, hasAlarms }: BottomNavigationProps) {
  const tabs = [
    { id: 'home' as MainTabType, label: '홈', icon: HomeIcon },
    { id: 'devices' as MainTabType, label: '기기', icon: LayoutGridIcon },
    { id: 'automation' as MainTabType, label: '자동화', icon: PlayCircleIcon },
    { id: 'menu' as MainTabType, label: '메뉴', icon: MenuIcon, badge: hasAlarms },
  ];

  return (
    <div
      className="fixed bottom-0 left-0 right-0 max-w-md mx-auto z-40 border-t backdrop-blur-xl flex items-center justify-around px-3 select-none"
      style={{
        backgroundColor: 'var(--mobile-bg-header)',
        borderColor: 'var(--mobile-border)',
        height: 'calc(3.75rem + env(safe-area-inset-bottom, 0px))',
        paddingBottom: 'env(safe-area-inset-bottom, 0px)'
      }}
    >
      {tabs.map((tab) => {
        const Icon = tab.icon;
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            onClick={() => onChangeTab(tab.id)}
            className="flex-1 flex flex-col items-center justify-center py-1 relative transition-colors duration-150 active:scale-95"
          >
            <div className="relative">
              <Icon
                className={`w-5 h-5 mb-0.5 transition-colors ${
                  isActive ? 'text-cyan-400' : 'text-slate-400 dark:text-slate-500'
                }`}
              />
              {tab.badge && (
                <span className="absolute -top-0.5 -right-1 w-2 h-2 rounded-full bg-red-500 ring-2 ring-[var(--mobile-bg)]" />
              )}
            </div>
            <span
              className={`text-[0.7rem] font-medium tracking-tight ${
                isActive ? 'text-cyan-400 font-bold' : 'text-slate-500'
              }`}
            >
              {tab.label}
            </span>
          </button>
        );
      })}
    </div>
  );
}
